import React, { useEffect, useRef, useContext, useState } from "react";
import { fabric } from "fabric";
import "./home.scss";
import { ProjectContext } from "../utils/projectContext";
import "../utils/guideline";
import bg1 from "../imgs/bg1.png";
import { AlignGuidelines } from "fabric-guideline-plugin";
import { saveAs } from "file-saver";
import { message, notification } from "antd";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { Input } from "antd";
import errorRed from "../imgs/error_red.png";
import satisfied from "../imgs/satisfied.png";
import { saveProject, createProject } from "../api/project";
import { useRequest } from "ahooks";
import { nanoid } from "nanoid";
import html2canvas from "html2canvas";

const Home = (props) => {
  const canvasRef = useRef(null);
  const { width, height } = props.stageDimensions;
  const { canvasStyle, name } = props.data;
  const { text, setText } = useContext(ProjectContext);
  // const { setUnactive } = useContext(ProjectContext);
  const { fontStyle, setFontStyle } = useContext(ProjectContext);
  const { fontStyleBtn, setFontStyleBtn } = useContext(ProjectContext);
  const { layerCount, setLayerCount } = useContext(ProjectContext);
  const { layerNow, setLayerNow } = useContext(ProjectContext);
  const { imgs, setImgs } = useContext(ProjectContext);
  const { save, setSave } = useContext(ProjectContext);
  const { checkObj, setCheckObj } = useContext(ProjectContext);
  const { changeName, setChangeName } = useContext(ProjectContext);
  const { setShowDynamic } = useContext(ProjectContext);
  const { dynamic, setDynamic } = useContext(ProjectContext);
  const { newZone } = useContext(ProjectContext);
  const { cars, setCars } = useContext(ProjectContext);
  const { setShowZone } = useContext(ProjectContext);
  const { customTypeName, setCustomTypeName } = useContext(ProjectContext);
  const { setShowData } = useContext(ProjectContext);
  const { setCustomTypeNameArr } = useContext(ProjectContext);
  // const [open, setOpen] = useState(false);
  // const [channel, setChannel] = useState("");
  // const [transferMessage, setTransferMessage] = useState({});
  const { customFeatures, setCustomFeatures } = useContext(ProjectContext);
  const { setActiveSecondKey } = useContext(ProjectContext);
  const { setShowFont } = useContext(ProjectContext);
  const { category, setCategory } = useContext(ProjectContext);
  const { iconExclusivity, setIconExclusivity } = useContext(ProjectContext);
  const { newCanvas, setNewCanvas } = useContext(ProjectContext);
  const { setShowIconExclusive } = useContext(ProjectContext);
  const { imageStyles, setImageStyles } = useContext(ProjectContext);
  const { newCanvasName, setNewCanvasName } = useContext(ProjectContext);
  let [blob, setBlob] = useState(null);
  const { newApiName } = useContext(ProjectContext);
  const { activeKey, setActiveKey } = useContext(ProjectContext);
  const { showIcons, setShowIcons } = useContext(ProjectContext);
  const { newDuplicateIcons } = useContext(ProjectContext);
  const { showCloudCity } = useContext(ProjectContext);
  const { shouldDownloadJson, setShouldDownloadJson } = useContext(ProjectContext);
  const { saveCallback } = useContext(ProjectContext);

  // 撤销/恢复历史记录栈 - 合并成一个对象避免状态不同步
  const [historyState, setHistoryState] = useState({
    records: [], // 历史记录数组
    currentStep: 0, // 当前步骤索引
  });
  const [clipboard, setClipboard] = useState(null);
  const isPerformingAction = useRef(false);
  const layerCountRef = useRef(layerCount); // 使用 ref 保存最新的 layerCount

  // 同步更新 layerCountRef
  useEffect(() => {
    layerCountRef.current = layerCount;
  }, [layerCount]);

  const { runAsync: createProjectRequest } = useRequest(createProject, {
    manual: true,
    onSuccess: (res) => {
      if (res.code === 200) {
        // console.log("Project created successfully:", res.data);
        localStorage.setItem("projectId", res.data.id);
      }
    },
    onError: (err) => {
      console.error("Error creating project:", err);
    },
  });

  const { runAsync: saveProjectRequest } = useRequest(saveProject, {
    manual: true,
    onSuccess: (res) => {
      if (res.code === 200) {
        // console.log("Project saved successfully:", res.data);
        message.success("保存成功");
      } else {
        message.error(res.msg);
      }
    },
    onError: (err) => {
      message.error(err.message);
    },
  });

  useEffect(() => {
    const canvas = fabricCanvasRef.current;
    if (canvas) {
      const objs = canvas.getObjects();
      const klass = objs.find((obj) => obj.index?.index === layerNow);

      if (klass) {
        klass.set({ apiName: newApiName });
        canvas.renderAll();
      }
    }
  }, [newApiName]);

  useEffect(() => {
    const canvas = fabricCanvasRef.current;
    if (canvas) {
      const objs = canvas.getObjects();
      const klass = objs.find((obj) => obj.index?.index === layerNow);
      if (klass) {
        objs.forEach((obj) => {
          if (obj.parent === klass.name) {
            obj.set({ parent: newCanvasName });
          }
        });
        klass.set({ name: newCanvasName });
        if (klass.type === "group") {
          klass.getObjects().forEach((obj) => {
            if (obj.type === "textbox") {
              obj.set({ text: newCanvasName });
            }
          });
        } else if (klass.type === "textbox") {
          klass.set({ text: newCanvasName });
        }
        canvas.renderAll();
      }
    }
  }, [newCanvasName]);

  // 辅助函数：安全获取下一个可用的 index
  const getNextIndex = (prevLayerCount) => {
    if (!prevLayerCount || prevLayerCount.length === 0) {
      return 0;
    }
    const maxIndex = Math.max(...prevLayerCount.map(layer => layer.index));
    return maxIndex + 1;
  };

  const imageStylesInit = {
    left: "",
    top: "",
    angle: "",
    width: "",
    height: "",
  };
  message.config({
    maxCount: 1,
    duration: 4,
  });

  const importAll = (r) => {
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace("./", "")] = r(item)?.default;
    });
    return images;
  };

  const fabricCanvasRef = useRef(null);
  const lastPositionRef = useRef({}); // 用于记录对象上次的位置
  let isDragging = false;
  let lastPosX = 0;
  let lastPosY = 0;
  let type = localStorage.getItem("type");

  const debounce = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  };

  // 保存当前canvas状态到历史记录
  const saveHistory = () => {
    const canvas = fabricCanvasRef.current;
    if (!canvas || isPerformingAction.current) {
      console.log("跳过保存历史记录 - canvas:", !!canvas, "isPerformingAction:", isPerformingAction.current);
      return;
    }
    
    const json = canvas.toJSON([
      "name",
      "selectable",
      "evented",
      "index",
      "opacityOriginal",
      "layerType",
      "dynamic",
      "cars",
      "customTypeName",
      "category",
      "iconExclusivity",
      "parent",
      "apiName",
      "fileName",
      "categoryId",
      "duplicateIconCategoryId",
      "duplicateIcons",
      "root",
      "id",
    ]);

    // 使用 ref 获取最新的 layerCount，避免闭包问题
    const currentLayerCount = layerCountRef.current;
    
    console.log("准备保存历史 - layerCount 长度:", currentLayerCount.length, "是否为空:", currentLayerCount.length === 0);

    // 使用单一 state 更新，确保 records 和 currentStep 同步
    setHistoryState((prev) => {
      // 删除当前步骤之后的所有历史记录（用于在中间步骤进行新操作时）
      const newRecords = prev.records.slice(0, prev.currentStep);
      const newRecord = { 
        canvas: json, 
        layerCount: currentLayerCount.length > 0 ? [...currentLayerCount] : [] 
      };
      newRecords.push(newRecord);
      
      let newStep = newRecords.length;
      
      // 限制历史记录数量为50
      if (newRecords.length > 50) {
        newRecords.shift();
        newStep = 49;
        console.log("历史记录达到上限，删除最旧的记录");
      }
      
      console.log("保存历史记录 - 当前 step:", prev.currentStep, "新 records 长度:", newRecords.length, "新 step:", newStep, "layerCount 长度:", currentLayerCount.length);
      
      return {
        records: newRecords,
        currentStep: newStep,
      };
    });
  };

  // 撤销操作
  const undo = () => {
    const canvas = fabricCanvasRef.current;
    
    const { records, currentStep } = historyState;
    console.log("撤销操作 - currentStep:", currentStep, "records.length:", records.length);
    
    if (!canvas) {
      console.log("Canvas不存在");
      return;
    }
    
    // currentStep 指向当前状态后面，需要至少有两个状态才能撤销（当前状态 + 上一个状态）
    if (currentStep <= 1 || records.length === 0) {
      message.info("没有可撤销的操作");
      console.log("无法撤销 - currentStep:", currentStep, "records.length:", records.length);
      return;
    }

    // currentStep 指向数组长度，当前显示的是 records[currentStep-1]
    // 撤销应该加载 records[currentStep-2]
    const prevIndex = currentStep - 2;
    console.log("尝试加载历史记录索引:", prevIndex, "该记录的 layerCount 长度:", records[prevIndex]?.layerCount?.length);
    
    if (prevIndex < 0 || !records[prevIndex]) {
      message.info("没有可撤销的操作");
      console.log("历史记录不存在 - prevIndex:", prevIndex);
      return;
    }

    isPerformingAction.current = true;
    const prevState = records[prevIndex];
    
    // 保存背景图对象引用，避免闪烁
    const bgImage = canvas.getObjects().find(obj => obj.name === "bgImage");
    
    // 移除除背景图外的所有对象
    const objectsToRemove = canvas.getObjects().filter(obj => obj.name !== "bgImage");
    objectsToRemove.forEach(obj => canvas.remove(obj));
    
    canvas.loadFromJSON(prevState.canvas, () => {
      // 确保背景图在最底层
      if (bgImage) {
        canvas.sendToBack(bgImage);
      }
      canvas.renderAll();
      setLayerCount(prevState.layerCount || []);
      setTimeout(() => {
        isPerformingAction.current = false;
      }, 100);
      console.log("撤销完成，新的 currentStep:", currentStep - 1, "恢复的 layerCount 长度:", prevState.layerCount?.length);
    });

    setHistoryState((prev) => ({
      ...prev,
      currentStep: Math.max(0, prev.currentStep - 1),
    }));
    
    message.success("撤销成功");
  };

  // 恢复操作
  const redo = () => {
    const canvas = fabricCanvasRef.current;
    
    const { records, currentStep } = historyState;
    console.log("恢复操作 - currentStep:", currentStep, "records.length:", records.length);
    
    if (!canvas) {
      console.log("Canvas不存在");
      return;
    }
    
    // currentStep 指向当前状态后面，需要有后续状态才能恢复
    if (currentStep >= records.length) {
      message.info("没有可恢复的操作");
      console.log("无法恢复 - currentStep:", currentStep, "records.length:", records.length);
      return;
    }

    const nextIndex = currentStep;
    console.log("尝试加载历史记录索引:", nextIndex, "该记录的 layerCount 长度:", records[nextIndex]?.layerCount?.length);
    
    if (nextIndex >= records.length || !records[nextIndex]) {
      message.info("没有可恢复的操作");
      console.log("历史记录不存在 - nextIndex:", nextIndex);
      return;
    }

    isPerformingAction.current = true;
    const nextState = records[nextIndex];
    
    // 保存背景图对象引用，避免闪烁
    const bgImage = canvas.getObjects().find(obj => obj.name === "bgImage");
    
    // 移除除背景图外的所有对象
    const objectsToRemove = canvas.getObjects().filter(obj => obj.name !== "bgImage");
    objectsToRemove.forEach(obj => canvas.remove(obj));
    
    canvas.loadFromJSON(nextState.canvas, () => {
      // 确保背景图在最底层
      if (bgImage) {
        canvas.sendToBack(bgImage);
      }
      canvas.renderAll();
      setLayerCount(nextState.layerCount || []);
      setTimeout(() => {
        isPerformingAction.current = false;
      }, 100);
      console.log("恢复完成，新的 currentStep:", currentStep + 1, "恢复的 layerCount 长度:", nextState.layerCount?.length);
    });

    setHistoryState((prev) => ({
      ...prev,
      currentStep: Math.min(records.length, prev.currentStep + 1),
    }));
    
    message.success("恢复成功");
  };

  // 复制操作
  const copyObject = () => {
    const canvas = fabricCanvasRef.current;
    if (!canvas) return;

    const activeObj = canvas.getActiveObject();
    if (!activeObj) {
      message.warning("请先选择要复制的对象");
      return;
    }

    // 排除背景图
    if (activeObj.name === "bgImage") {
      message.warning("该对象不能被复制");
      return;
    }

    // 检查是否为多选（ActiveSelection）
    if (activeObj.type === "activeSelection") {
      const objects = activeObj.getObjects();
      // 检查是否包含不可复制的对象
      const hasInvalidObject = objects.some(obj => 
        obj.name === "bgImage" || (obj.type === "rect" && obj.index?.index === 0)
      );
      
      if (hasInvalidObject) {
        message.warning("选中的对象中包含不可复制的对象");
        return;
      }
    } else if (activeObj.type === "rect" && activeObj.index?.index === 0) {
      // 单个对象且是主画布
      message.warning("该对象不能被复制");
      return;
    }

    activeObj.clone((cloned) => {
      setClipboard(cloned);
      message.success("复制成功");
    }, [
      "name",
      "selectable",
      "evented",
      "index",
      "opacityOriginal",
      "layerType",
      "dynamic",
      "cars",
      "customTypeName",
      "category",
      "iconExclusivity",
      "parent",
      "apiName",
      "fileName",
      "categoryId",
      "duplicateIconCategoryId",
      "duplicateIcons",
      "root",
      "id",
    ]);
  };

  // 粘贴操作
  const pasteObject = () => {
    const canvas = fabricCanvasRef.current;
    if (!canvas) return;

    if (!clipboard) {
      message.warning("剪贴板为空");
      return;
    }

    // 设置标记，防止在粘贴过程中多次保存历史记录
    isPerformingAction.current = true;

    clipboard.clone((clonedObj) => {
      canvas.discardActiveObject();
      
      // 检查是否为多选对象（ActiveSelection）
      if (clonedObj.type === "activeSelection") {
        const objects = clonedObj.getObjects();
        const newObjects = [];
        
        setLayerCount((prevLayerCount) => {
          let currentLayerCount = [...prevLayerCount];
          
          // 为每个对象分配新的 index 并添加到画布
          objects.forEach((obj) => {
            const nextIndex = getNextIndex(currentLayerCount);
            let newName = obj.name;
            
            // 获取对象在画布上的绝对位置
            // 需要考虑 ActiveSelection 的变换
            const matrix = clonedObj.calcTransformMatrix();
            const point = new fabric.Point(obj.left, obj.top);
            const transformedPoint = fabric.util.transformPoint(point, matrix);
            
            // 设置新对象的位置（使用变换后的坐标并添加偏移）
            obj.set({
              left: transformedPoint.x + 10,
              top: transformedPoint.y + 10,
              evented: true,
            });
            
            // 根据对象类型处理
            if (obj.type === "group") {
              // 功能分区
              const baseName = obj.name.replace(/\s*\d+$/, '');
              let suffix = 1;
              let candidateName = `${baseName} ${suffix}`;
              
              while (currentLayerCount.some(layer => layer.name === candidateName)) {
                suffix++;
                candidateName = `${baseName} ${suffix}`;
              }
              
              newName = candidateName;
              
              if (obj._objects) {
                obj.getObjects().forEach((subObj) => {
                  if (subObj.type === "textbox") {
                    subObj.set({ text: newName });
                  }
                });
              }
              
              obj.set({
                name: newName,
                index: {
                  ...obj.index,
                  index: nextIndex,
                },
              });
              
              // 添加缩放处理
              handleGroupScaling(obj);
              
              currentLayerCount.push({
                index: nextIndex,
                visiable: true,
                opacity: 0.3,
                backgroundColor: "#56A5EF",
                name: newName,
                root: obj.root,
                type: "功能分区",
                apiName: obj.apiName,
                tempName: newName,
              });
            } else if (obj.type === "textbox" && obj.parent) {
              // 文本对象
              const baseName = "文本";
              let suffix = 1;
              let candidateName = `${baseName}${suffix}`;
              
              while (currentLayerCount.some(layer => layer.fileName === candidateName)) {
                suffix++;
                candidateName = `${baseName}${suffix}`;
              }
              
              obj.set({ 
                text: candidateName,
                index: {
                  ...obj.index,
                  index: nextIndex,
                },
              });
              
              currentLayerCount.push({
                index: nextIndex,
                visiable: true,
                layerType: "text",
                opacity: obj.opacity || obj.opacityOriginal || 1,
                parent: obj.parent,
                root: obj.root,
                type: "文本",
                apiName: obj.apiName,
                fileName: candidateName,
                color: obj.fill,
              });
            } else if (obj.type === "image" && obj.fileName) {
              // 图标对象
              obj.set({
                index: {
                  ...obj.index,
                  index: nextIndex,
                },
              });
              
              currentLayerCount.push({
                index: nextIndex,
                visiable: true,
                layerType: "image",
                opacity: obj.opacity || obj.opacityOriginal || 1,
                parent: obj.parent,
                root: obj.root,
                type: "图标",
                apiName: obj.apiName,
                fileName: obj.fileName,
                duplicateIconCategoryId: obj.duplicateIconCategoryId,
                duplicateIcons: obj.duplicateIcons,
              });
            } else if (obj.type === "rect" && obj.id) {
              // 画布对象
              const newId = nanoid();
              const baseName = obj.name.replace(/\s*\d+$/, '');
              let suffix = 1;
              let candidateName = `${baseName}${suffix}`;
              
              while (currentLayerCount.some(layer => layer.name === candidateName)) {
                suffix++;
                candidateName = `${baseName}${suffix}`;
              }
              
              newName = candidateName;
              
              obj.set({
                name: newName,
                id: newId,
                index: {
                  ...obj.index,
                  index: nextIndex,
                },
              });
              
              currentLayerCount.push({
                index: nextIndex,
                visiable: true,
                backgroundColor: obj.fill,
                opacity: obj.opacity || obj.opacityOriginal || 1,
                name: newName,
                id: newId,
                type: "画布",
                apiName: obj.apiName || "Canvas",
              });
            } else {
              // 其他类型
              obj.set({
                index: {
                  ...obj.index,
                  index: nextIndex,
                },
              });
              
              currentLayerCount.push({
                index: nextIndex,
                visiable: true,
                opacity: obj.opacity || obj.opacityOriginal || 1,
                parent: obj.parent,
                root: obj.root,
                apiName: obj.apiName,
              });
            }
            
            canvas.add(obj);
            newObjects.push(obj);
          });
          
          // 选中所有新添加的对象
          if (newObjects.length > 0) {
            const selection = new fabric.ActiveSelection(newObjects, {
              canvas: canvas,
            });
            canvas.setActiveObject(selection);
            canvas.requestRenderAll();
          }
          
          // 释放标记并保存历史记录（只保存一次）
          setTimeout(() => {
            isPerformingAction.current = false;
            saveHistory();
          }, 100);
          
          return currentLayerCount;
        });
        
        message.success(`粘贴成功 (${objects.length} 个对象)`);
      } else {
        // 单个对象的粘贴逻辑（保持原有逻辑）
        // 设置新对象的位置（偏移一点）
        clonedObj.set({
          left: clonedObj.left + 10,
          top: clonedObj.top + 10,
          evented: true,
        });

        // 为新对象分配新的index
        setLayerCount((prevLayerCount) => {
          const nextIndex = getNextIndex(prevLayerCount);
          
          // 生成唯一名称
          let newName = clonedObj.name;
          
          // 为功能分区生成新的唯一名称
          if (clonedObj.type === "group") {
            // 查找同名的功能分区数量，生成唯一名称
            const baseName = clonedObj.name.replace(/\s*\d+$/, ''); // 移除末尾的数字
            let suffix = 1;
            let candidateName = `${baseName} ${suffix}`;
            
            while (prevLayerCount.some(layer => layer.name === candidateName)) {
              suffix++;
              candidateName = `${baseName} ${suffix}`;
            }
            
            newName = candidateName;
            
            // 更新组内文本对象的内容
            if (clonedObj._objects) {
              clonedObj.getObjects().forEach((obj) => {
                if (obj.type === "textbox") {
                  obj.set({ text: newName });
                }
              });
            }
            
            // 功能分区只需要更新 name，不需要 id
            clonedObj.set({
              name: newName,
              index: {
                ...clonedObj.index,
                index: nextIndex,
              },
            });
          } else if (clonedObj.type === "textbox" && clonedObj.parent) {
            // 为文本对象生成新名称
            const baseName = "文本";
            let suffix = 1;
            let candidateName = `${baseName}${suffix}`;
            
            while (prevLayerCount.some(layer => layer.fileName === candidateName)) {
              suffix++;
              candidateName = `${baseName}${suffix}`;
            }
            
            clonedObj.set({ 
              text: candidateName,
              index: {
                ...clonedObj.index,
                index: nextIndex,
              },
            });
          } else if (clonedObj.type === "image" && clonedObj.fileName) {
            // 图标保持原文件名，但需要更新 index
            clonedObj.set({
              index: {
                ...clonedObj.index,
                index: nextIndex,
              },
            });
          } else if (clonedObj.type === "rect" && clonedObj.id) {
            // 画布需要新的 id 和 name
            const newId = nanoid();
            const baseName = clonedObj.name.replace(/\s*\d+$/, '');
            let suffix = 1;
            let candidateName = `${baseName}${suffix}`;
            
            while (prevLayerCount.some(layer => layer.name === candidateName)) {
              suffix++;
              candidateName = `${baseName}${suffix}`;
            }
            
            newName = candidateName;
            
            clonedObj.set({
              name: newName,
              id: newId,
              index: {
                ...clonedObj.index,
                index: nextIndex,
              },
            });
          } else {
            // 其他类型的对象
            clonedObj.set({
              index: {
                ...clonedObj.index,
                index: nextIndex,
              },
            });
          }

          canvas.add(clonedObj);
          canvas.setActiveObject(clonedObj);
          canvas.requestRenderAll();

          // 释放标记并保存历史记录（只保存一次）
          setTimeout(() => {
            isPerformingAction.current = false;
            saveHistory();
          }, 100);

          // 根据对象类型添加到图层列表
          const newLayer = {
            index: nextIndex,
            visiable: true,
            opacity: clonedObj.opacity || clonedObj.opacityOriginal || 1,
            parent: clonedObj.parent,
            root: clonedObj.root,
            apiName: clonedObj.apiName,
          };

          if (clonedObj.type === "textbox") {
            newLayer.type = "文本";
            newLayer.layerType = "text";
            newLayer.fileName = clonedObj.text;
            newLayer.color = clonedObj.fill;
          } else if (clonedObj.type === "image") {
            newLayer.type = "图标";
            newLayer.layerType = "image";
            newLayer.fileName = clonedObj.fileName;
            newLayer.duplicateIconCategoryId = clonedObj.duplicateIconCategoryId;
            newLayer.duplicateIcons = clonedObj.duplicateIcons;
          } else if (clonedObj.type === "group") {
            newLayer.type = "功能分区";
            newLayer.name = newName;
            newLayer.backgroundColor = "#56A5EF";
            newLayer.tempName = newName;
            
            // 为新功能分区添加缩放处理
            handleGroupScaling(clonedObj);
          } else if (clonedObj.type === "rect" && clonedObj.id) {
            // 画布类型
            newLayer.type = "画布";
            newLayer.name = newName;
            newLayer.id = clonedObj.id;
            newLayer.backgroundColor = clonedObj.fill;
            newLayer.apiName = clonedObj.apiName || "Canvas";
          }

          setLayerNow(nextIndex);
          
          console.log("粘贴完成 - 新对象:", {
            type: clonedObj.type,
            name: newName,
            id: clonedObj.id || "(无ID)",
            index: nextIndex
          });
          
          return [...prevLayerCount, newLayer];
        });

        message.success("粘贴成功");
      }
    }, [
      "name",
      "selectable",
      "evented",
      "index",
      "opacityOriginal",
      "layerType",
      "dynamic",
      "cars",
      "customTypeName",
      "category",
      "iconExclusivity",
      "parent",
      "apiName",
      "fileName",
      "categoryId",
      "duplicateIconCategoryId",
      "duplicateIcons",
      "root",
      "id",
    ]);
  };

  const debouncedScalingMessage = debounce((type, content, opacity) => {
    message.open({
      type: type,
      content: content,
      style: {
        opacity: opacity,
        fontSize: "30px",
      },
    });
  }, 100);

  useEffect(() => {
    if (canvasRef.current && width && height) {
      // 初始化时设置标记，防止保存历史记录
      isPerformingAction.current = true;
      
      const initCanvas = new fabric.Canvas(canvasRef.current, {
        backgroundColor: "transparent",
        selection: false,
        width: width,
        height: height,
        selectionFullyContained: true,
        preserveObjectStacking: true,
      });
      initCanvas.renderAll();
      const canvas = fabricCanvasRef.current;
      const guideline = new AlignGuidelines({
        canvas: initCanvas,
        aligningOptions: {
          lineWidth: 2,
        },
      });
      guideline.init();
      // console.log(props.data, "props.data");
      let newCanvas = [];
      if (localStorage.getItem("canvasArr")) {
        newCanvas = JSON.parse(localStorage.getItem("canvasArr")).filter(
          (item) => item.name === name
        );
      }

      let initialCheckObj = {
        "bounding box": false,
        "lateral risk field": false,
        mask: false,
        "vertical risk field": false,
      };
      fabric.Image.fromURL(bg1, function (oImg) {
        oImg.set({
          selectable: false,
          evented: false,
          name: "bgImage",
        });
        initCanvas.add(oImg);
        initCanvas.sendToBack(oImg);
      });
      if (newCanvas.length > 0 || props.data.background) {
        // console.log(newCanvas[0] || props.data, "newCanvas");
        //清空layerCount
        setLayerCount([]);
        (newCanvas[0] || props.data)?.objects.forEach((obj) => {
          let klassObj;
          switch (obj.type) {
            case "rect":
              klassObj = new fabric.Rect(obj);
              setLayerCount((prevLayerCount) => {
                const exists = prevLayerCount.some((layer) => layer.index === obj.index.index);
                if (exists) {
                  return prevLayerCount.map((layer) =>
                    layer.index === obj.index.index
                      ? {
                          ...layer,
                          backgroundColor: klassObj.fill,
                          opacity: klassObj.opacity,
                          name: klassObj.name,
                          id: obj.id,
                          type: "画布",
                          apiName: obj.apiName,
                        }
                      : layer
                  );
                } else {
                  return [
                    ...prevLayerCount,
                    {
                      index: obj.index.index,
                      visiable: true,
                      backgroundColor: klassObj.fill,
                      opacity: klassObj.opacity,
                      name: klassObj.name,
                      id: obj.id,
                      type: "画布",
                      apiName: obj.apiName,
                    },
                  ];
                }
              });
              const viewportTransform = initCanvas.viewportTransform;
              viewportTransform[4] = -klassObj.left + initCanvas.width / 2 - klassObj.width / 2;
              viewportTransform[5] = -klassObj.top + initCanvas.height / 2 - klassObj.height / 2;
              initCanvas.setViewportTransform(viewportTransform);
              break;
            case "group":
              fabric.Group.fromObject(obj, function (group) {
                setLayerCount((prevLayerCount) => [
                  ...prevLayerCount,
                  {
                    index: obj.index.index,
                    visiable: true,
                    opacity: 0.3,
                    backgroundColor: "#56A5EF",
                    name: obj.name,
                    root: obj.root,
                    type: "功能分区",
                    apiName: obj.apiName,
                    tempName: obj.name,
                  },
                ]);
                initCanvas.add(group);
                handleGroupScaling(group);
              });
              //   klassObj = new fabric.Group(obj.objects[0], obj.objects[1]);
              //   klassObj.set(obj);
              //   klassObj.set({
              //     fill: obj.objects[0].fill,
              //   });
              //   setLayerCount((prevLayerCount) => [
              //     ...prevLayerCount,
              //     {
              //       index: obj.index.index,
              //       visiable: true,
              //       opacity: 0.3,
              //       backgroundColor: "#56A5EF",
              //       name: obj.name,
              //     },
              //   ]);
              break;
            case "textbox":
              klassObj = new fabric.Textbox(obj.text, obj);
              setLayerCount((prevLayerCount) =>
                [
                  ...prevLayerCount,
                  {
                    index: klassObj.index.index,
                    visiable: true,
                    layerType: klassObj.layerType,
                    opacity: klassObj.opacity,
                    parent: obj.parent,
                    root: obj.root,
                    type: "文本",
                    apiName: obj.apiName,
                    fileName: obj.text,
                    color: obj.fill,
                  },
                ].sort((a, b) => a.index - b.index)
              );
              break;
            case "image":
              if (obj.name === "image") {
                fabric.Image.fromURL(
                  obj.src,
                  (img) => {
                    img.set(obj);
                    initCanvas.add(img);
                    setLayerCount((prevLayerCount) =>
                      [
                        ...prevLayerCount,
                        {
                          index: obj.index.index,
                          visiable: true,
                          layerType: obj.layerType,
                          opacity: obj.opacity,
                          parent: obj.parent,
                          root: obj.root,
                          // categoryId: obj?.categoryId,
                          duplicateIconCategoryId: obj?.duplicateIconCategoryId,
                          duplicateIcons: obj?.duplicateIcons,
                          type: "图标",
                          apiName: obj.apiName,
                          fileName: obj.fileName,
                        },
                      ].sort((a, b) => a.index - b.index)
                    );
                  },
                  { crossOrigin: "anonymous" }
                );
              } else if (
                obj.name !== "image" &&
                obj.name !== "bgImage" &&
                obj.name !== "bounding box1" &&
                obj.name !== "bounding box2"
              ) {
                setCheckObj((prevCheckObj) => {
                  return { ...prevCheckObj, [obj.name]: true };
                });
              }
              break;
            default:
              return;
          }

          if (initialCheckObj.hasOwnProperty(obj.name)) {
            initialCheckObj[obj.name] = true;
          }

          if (klassObj) {
            initCanvas.add(klassObj);
            if (obj.index.index === 0) {
              setFontStyle({
                index: 0,
                opacity: klassObj.opacityOriginal,
              });
            }
          }
        });
        setCheckObj(initialCheckObj);
        if (newCanvas[0]?.checkObj) {
          setCheckObj(newCanvas[0].checkObj);
        }
      } else {
        setCheckObj(initialCheckObj);
        let rect = new fabric.Rect({
          opacity: 0.3,
          opacityOriginal: 0.3,
          left: (width - Number(canvasStyle.width)) / 2 + 800,
          top: (height - Number(canvasStyle.height)) / 2 + 250,
          fill: canvasStyle.backgroundColor,
          width: Number(canvasStyle.width),
          height: Number(canvasStyle.height),
          name: "Canvas画布",
          id: nanoid(),
          lockRotation: true,
          selectable: true,
          evented: true,
          apiName: "Canvas",
          index: {
            index: 0,
            visiable: true,
            backgroundColor: canvasStyle.backgroundColor,
            opacity: 0.3,
          },
          hoverCursor: "default",
        });
        setLayerCount([
          {
            index: 0,
            visiable: true,
            backgroundColor: canvasStyle.backgroundColor,
            opacity: 0.3,
            name: rect.name,
            id: rect.id,
            type: "画布",
            apiName: "Canvas",
          },
          {
            index: 1,
            visiable: true,
            backgroundColor: "#56A5EF",
            opacity: 0.3,
            name: "道路信息",
            root: rect.id,
            type: "功能分区",
            apiName: "roadInformation",
            tempName: "道路信息",
          },
          {
            index: 3,
            visiable: true,
            backgroundColor: "#56A5EF",
            opacity: 0.3,
            name: "车辆信息",
            root: rect.id,
            type: "功能分区",
            apiName: "vehicleInformation",
            tempName: "车辆信息",
          },
          {
            index: 4,
            visiable: true,
            backgroundColor: "#56A5EF",
            opacity: 0.3,
            name: "导航信息",
            root: rect.id,
            type: "功能分区",
            apiName: "navigationInformation",
            tempName: "导航信息",
          },
        ]);
        const viewportTransform = initCanvas.viewportTransform;
        viewportTransform[4] = -rect.left + initCanvas.width / 2 - rect.width / 2;
        viewportTransform[5] = -rect.top + initCanvas.height / 2 - rect.height / 2;
        initCanvas.setViewportTransform(viewportTransform);
        initCanvas.zoomToPoint(
          {
            x: initCanvas.width / 2,
            y: initCanvas.height / 2,
          },
          0.7
        );
        let functionRect1 = new fabric.Rect({
          left: (width - Number(canvasStyle.width)) / 2 + 20 + 800,
          top: (height - Number(canvasStyle.height)) / 2 + 20 + 240,
          width: 240,
          height: 120,
          fill: "#56A5EF",
          name: "function rect1",
        });
        let functionName1 = new fabric.Textbox("道路信息", {
          left: (width - Number(canvasStyle.width)) / 2 + 20 + 800,
          top: (height - Number(canvasStyle.height)) / 2 + 20 + 240,
          fill: "black",
          name: "function name1",
          fontSize: 18,
          originX: "left",
          originY: "top",
          width: 200,
        });
        let functionGroup1 = new fabric.Group([functionRect1, functionName1], {
          name: "道路信息",
          opacity: 0.3,
          opacityOriginal: 0.3,
          root: rect.id,
          apiName: "roadInformation",
          index: {
            index: 1,
            visiable: true,
            opacity: 0.3,
          },
        });
        // let functionRect2 = new fabric.Rect({
        //   left: (width - Number(canvasStyle.width)) / 2 + 20+1232,
        //   top: (height - Number(canvasStyle.height)) / 2 + 450+459,
        //   width: 400,
        //   height: 200,
        //   fill: "#56A5EF",
        //   name: "function rect2",
        // });
        // let functionName2 = new fabric.Textbox("警示信息", {
        //   left: (width - Number(canvasStyle.width)) / 2 + 30+1232,
        //   top: (height - Number(canvasStyle.height)) / 2 + 460+459,
        //   fill: "black",
        //   name: "function name2",
        //   fontSize: 18,
        // });
        // let functionGroup2 = new fabric.Group([functionRect2, functionName2], {
        //   opacity: 0.3,
        //   opacityOriginal: 0.3,
        //   name: "警示信息",
        //   index: {
        //     index: 2,
        //     visiable: true,
        //     opacity: 0.3,
        //   },
        // });
        let functionRect3 = new fabric.Rect({
          left: (width - Number(canvasStyle.width)) / 2 + 460 + 620,
          top:
            (height - Number(canvasStyle.height)) / 2 + Number(canvasStyle.height) - 300 - 70 + 430,
          width: 340,
          height: 180,
          fill: "#56A5EF",
          name: "function rect3",
        });
        let functionName3 = new fabric.Textbox("车辆信息", {
          left: (width - Number(canvasStyle.width)) / 2 + 460 + 620,
          top:
            (height - Number(canvasStyle.height)) / 2 + Number(canvasStyle.height) - 300 - 70 + 430,
          fill: "black",
          name: "function name3",
          fontSize: 18,
          width: 200,
        });
        let functionGroup3 = new fabric.Group([functionRect3, functionName3], {
          opacity: 0.3,
          opacityOriginal: 0.3,
          name: "车辆信息",
          root: rect.id,
          apiName: "vehicleInformation",
          index: {
            index: 3,
            visiable: true,
            opacity: 0.3,
          },
        });
        let functionRect4 = new fabric.Rect({
          left: (width - Number(canvasStyle.width)) / 2 + 1280 - 600 - 20 + 780,
          top: (height - Number(canvasStyle.height)) / 2 + 20 + 240,
          width: 240,
          height: 200,
          fill: "#56A5EF",
          name: "function rect4",
        });
        let functionName4 = new fabric.Textbox("导航信息", {
          left: (width - Number(canvasStyle.width)) / 2 + 1280 - 600 - 20 + 780,
          top: (height - Number(canvasStyle.height)) / 2 + 20 + 240,
          fill: "black",
          name: "function name4",
          fontSize: 18,
          width: 200,
        });
        let functionGroup4 = new fabric.Group([functionRect4, functionName4], {
          name: "导航信息",
          opacityOriginal: 0.3,
          root: rect.id,
          apiName: "navigationInformation",
          index: {
            index: 4,
            visiable: true,
            opacity: 0.3,
          },
          opacity: 0.3,
        });

        handleGroupScaling(functionGroup1);
        handleGroupScaling(functionGroup3);
        handleGroupScaling(functionGroup4);

        initCanvas.add(rect);
        initCanvas.add(functionGroup1);
        // initCanvas.add(functionGroup2);
        initCanvas.add(functionGroup3);
        initCanvas.add(functionGroup4);

        let json = initCanvas.toJSON([
          "name",
          "selectable",
          "evented",
          "index",
          "opacityOriginal",
          "layerType",
          "dynamic",
          "cars",
          "customTypeName",
          "category",
          "iconExclusivity",
          "parent",
          "apiName",
          "fileName",
          "categoryId",
          "duplicateIconCategoryId",
          "duplicateIcons",
          "root",
          "id",
        ]);
        json.id = localStorage.getItem("projectId") || "";
        initCanvas.set("id", json.id);
        saveProjectRequest({
          id: localStorage.getItem("projectId") || "",
          data: JSON.stringify(json),
        });
      }

      // console.log(initCanvas.getContext('2d').getImageData(200, 200, 1, 1).data);

      fabricCanvasRef.current = initCanvas;
      const handleMouseWheel = (opt) => {
        const delta = opt.e.deltaY;
        let zoom = initCanvas.getZoom();
        zoom *= 0.999 ** delta;
        if (zoom > 20) zoom = 20;
        if (zoom < 0.01) zoom = 0.01;
        initCanvas.zoomToPoint(
          {
            x: opt.e.offsetX,
            y: opt.e.offsetY,
          },
          zoom
        );
        opt.e.preventDefault();
        opt.e.stopPropagation();
      };

      const handleMouseDown = (opt) => {
        var evt = opt.e;
        if (evt.altKey === true) {
          isDragging = true;
          lastPosX = evt.clientX;
          lastPosY = evt.clientY;
          initCanvas.selection = false;
        }
      };

      const handleMouseMove = (opt) => {
        if (isDragging) {
          var e = opt.e;
          var vpt = initCanvas.viewportTransform;
          vpt[4] += e.clientX - lastPosX;
          vpt[5] += e.clientY - lastPosY;
          initCanvas.requestRenderAll();
          lastPosX = e.clientX;
          lastPosY = e.clientY;
        }
      };

      const handleMouseUp = () => {
        initCanvas.setViewportTransform(initCanvas.viewportTransform);
        isDragging = false;
        initCanvas.selection = true;

        const canvas = fabricCanvasRef.current;
        canvas.setViewportTransform(canvas.viewportTransform);
        isDragging = false;
        canvas.selection = true;
        removeSatisfied();
        removeLineAndDistance();
      };

      // 对象修改后保存历史记录
      const handleObjectModified = (e) => {
        // 排除距离提示相关的辅助对象（线条、文本、提示图标）
        if (e.target && (
          e.target.type === "line" || 
          e.target.type === "text" || 
          e.target.satisfied || 
          e.target.horizontalSatisfied || 
          e.target.verticalSatisfied
        )) {
          return;
        }
        setTimeout(() => {
          saveHistory();
        }, 100);
      };

      // 对象添加后保存历史记录
      const handleObjectAdded = (e) => {
        // 排除背景图的添加
        if (e.target && e.target.name === "bgImage") {
          return;
        }
        // 排除距离提示相关的辅助对象（线条、文本、提示图标）
        if (e.target && (
          e.target.type === "line" || 
          e.target.type === "text" || 
          e.target.satisfied || 
          e.target.horizontalSatisfied || 
          e.target.verticalSatisfied
        )) {
          return;
        }
        if (!isPerformingAction.current) {
          setTimeout(() => {
            saveHistory();
          }, 100);
        }
      };

      // 记录对象开始移动前的位置
      const handleObjectMouseDown = (e) => {
        if (e.target) {
          const objectId = e.target.id || e.target.name;
          lastPositionRef.current[objectId] = {
            left: e.target.left,
            top: e.target.top,
          };
        }
      };

      initCanvas.on("mouse:wheel", handleMouseWheel);
      initCanvas.on("mouse:down", handleMouseDown);
      initCanvas.on("mouse:down", handleObjectMouseDown);
      initCanvas.on("mouse:move", handleMouseMove);
      initCanvas.on("mouse:up", handleMouseUp);
      initCanvas.on("object:scaling", handleScaling);
      initCanvas.on("object:moving", handleMoving);
      initCanvas.on("object:modified", handleObjectModified);
      initCanvas.on("object:added", handleObjectAdded);

      // 初始化完成后保存初始状态
      setTimeout(() => {
        if (fabricCanvasRef.current) {
          // 释放初始化标记
          isPerformingAction.current = false;
          // 清空历史记录并保存初始状态
          setHistoryState({ records: [], currentStep: 0 });
          // 延迟一下再保存，确保所有对象都已加载
          setTimeout(() => {
            saveHistory();
            console.log("初始历史记录已保存 - currentStep: 0");
          }, 200);
        }
      }, 1500);

      return () => {
        if (initCanvas.cacheCanvasEl) {
          setCheckObj({});
          initCanvas.off("mouse:wheel", handleMouseWheel);
          initCanvas.off("mouse:down", handleMouseDown);
          initCanvas.off("mouse:down", handleObjectMouseDown);
          initCanvas.off("mouse:move", handleMouseMove);
          initCanvas.off("mouse:up", handleMouseUp);
          initCanvas.off("object:scaling", handleScaling);
          initCanvas.off("object:moving", handleMoving);
          initCanvas.off("object:modified", handleObjectModified);
          initCanvas.off("object:added", handleObjectAdded);
          // console.log(initCanvas, "inn2");
          initCanvas?.dispose();
          fabricCanvasRef.current = null;
          // 清空历史记录
          setHistoryState({ records: [], currentStep: 0 });
          console.log("Canvas已销毁，历史记录已清空");
        }
      };
    }
  }, [width, height, canvasStyle]);

  let isTextShown = false;
  const handleScaling = (e) => {
    const canvas = fabricCanvasRef.current;
    if (e.target.name === "image" && canvas) {
      if (e.target.scaleX <= e.target.minScaleLimit || e.target.scaleY <= e.target.minScaleLimit) {
        if (!isTextShown) {
          fabric.Image.fromURL(errorRed, function (oImg) {
            oImg.set({
              left: e.target.left + e.target.width * e.target.scaleX + 5,
              top: e.target.top + 19,
              selectable: false,
              evented: false,
            });

            oImg.scaleToHeight(15);

            const text = new fabric.Text("The minimum size of an \nicon should be 30 pixel", {
              left: e.target.left + e.target.width * e.target.scaleX + 20,
              top: e.target.top + 15,
              fill: "#000",
              fontSize: 20,
              selectable: false,
              evented: false,
              scaleX: 0.5,
              scaleY: 0.5,
            });

            const tipGroup = new fabric.Group([text, oImg], {
              selectable: false,
              evented: false,
            });
            canvas.add(tipGroup);

            setTimeout(() => {
              canvas.remove(tipGroup);
              isTextShown = false;
            }, 500);
            isTextShown = true;
          });
        }
      } else {
        // debouncedScalingMessage("success", "Satisfied!", 0.3);
      }
    } else if (e.target.name === "text") {
      if (e.target.scaleX < 1) {
        e.target.set({
          scaleX: 1,
          scaleY: 1,
        });
        // message.error('Failed！the minimum font scaling ratio should be 1,that is 24px');
        debouncedScalingMessage(
          "error",
          "Failed！the minimum font scaling ratio should be 1,that is 24px",
          1
        );
      } else {
        // message.success({
        //   content: 'Satisfied！',
        //   style:{
        //     opacity:0.3
        //   }
        // })
        debouncedScalingMessage("success", "Satisfied！", 0.3);
      }
    }
  };
  const handleGroupScaling = (group) => {
    group.on("scaling", () => {
      group.getObjects().forEach((obj) => {
        if (obj.type === "textbox") {
          const scaleX = 1 / group.scaleX;
          const scaleY = 1 / group.scaleY;
          obj.set({
            scaleX: scaleX,
            scaleY: scaleY,
          });
        }
      });
    });
  };

  useEffect(() => {
    const canvas = fabricCanvasRef.current;

    if (canvas && newCanvas) {
      setNewCanvas(false);
      // console.log(canvasStyle, newCanvas, "canvasStyle");
      let baseName = "Canvas画布";
      let existingNames = layerCount.filter((l) => l.id).map((l) => l.name);
      let suffix = 0;
      let newName = baseName;
      while (existingNames.includes(newName)) {
        suffix += 1;
        newName = `${baseName}${suffix}`;
      }

      setLayerCount((prevLayerCount) => {
        const nextIndex = getNextIndex(prevLayerCount);
        
        let rect = new fabric.Rect({
          opacity: 0.3,
          opacityOriginal: 0.3,
          left: 1203.5,
          top: 504,
          fill: "#fff",
          width: 900,
          height: 300,
          name: newName,
          id: nanoid(),
          lockRotation: true,
          selectable: true,
          evented: true,
          index: {
            index: nextIndex,
            visiable: true,
            backgroundColor: "#fff",
            opacity: 0.3,
          },
          hoverCursor: "default",
          apiName: "Canvas",
        });
        
        canvas.add(rect);
        
        return [
          ...prevLayerCount,
          {
            index: nextIndex,
            visiable: true,
            backgroundColor: "#fff",
            opacity: 0.3,
            name: rect.name,
            id: rect.id,
            type: "画布",
            apiName: "Canvas",
          },
        ];
      });
    }
  }, [newCanvas]);

  const calculateEdgeDistance = (obj1, obj2) => {
    const obj1Edges = {
      left: obj1.left,
      right: obj1.left + obj1.width * obj1.scaleX,
      top: obj1.top,
      bottom: obj1.top + obj1.height * obj1.scaleY,
    };

    const obj2Edges = {
      left: obj2.left,
      right: obj2.left + obj2.width * obj2.scaleX,
      top: obj2.top,
      bottom: obj2.top + obj2.height * obj2.scaleY,
    };

    const horizontalDistance = Math.max(
      0,
      obj1Edges.left - obj2Edges.right,
      obj2Edges.left - obj1Edges.right
    );
    const verticalDistance = Math.max(
      0,
      obj1Edges.top - obj2Edges.bottom,
      obj2Edges.top - obj1Edges.bottom
    );

    return { horizontalDistance, verticalDistance, obj1Edges, obj2Edges };
  };
  const drawLineAndDistance = (obj1, obj2, distanceInfo) => {
    const canvas = fabricCanvasRef.current;

    removeLineAndDistance();

    const { horizontalDistance, verticalDistance, obj1Edges, obj2Edges } = distanceInfo;

    if (horizontalDistance > 0 && horizontalDistance < 100 && obj1.parent === obj2.parent) {
      const horizontalLine1 = new fabric.Line(
        [
          obj1Edges.left < obj2Edges.left ? obj1Edges.right : obj1Edges.left,
          (obj1Edges.top + obj1Edges.bottom) / 2 - 5,
          obj1Edges.left < obj2Edges.left ? obj1Edges.right : obj1Edges.left,
          (obj1Edges.top + obj1Edges.bottom) / 2 + 5,
        ],
        {
          stroke: "black",
          selectable: false,
          evented: false,
        }
      );

      const horizontalLine2 = new fabric.Line(
        [
          obj2Edges.left < obj1Edges.left ? obj2Edges.right : obj2Edges.left,
          (obj2Edges.top + obj2Edges.bottom) / 2 - 5,
          obj2Edges.left < obj1Edges.left ? obj2Edges.right : obj2Edges.left,
          (obj2Edges.top + obj2Edges.bottom) / 2 + 5,
        ],
        {
          stroke: "black",
          selectable: false,
          evented: false,
        }
      );

      if (horizontalLine1.y1 === horizontalLine2.y1) {
        const verticalLine = new fabric.Line(
          [
            obj1Edges.left < obj2Edges.left ? obj1Edges.right : obj1Edges.left,
            (obj1Edges.top + obj1Edges.bottom) / 2,
            obj2Edges.left < obj1Edges.left ? obj2Edges.right : obj2Edges.left,
            (obj2Edges.top + obj2Edges.bottom) / 2,
          ],
          {
            stroke: "black",
            selectable: false,
            evented: false,
          }
        );
        canvas.add(verticalLine);
      } else {
        const verticalLine = new fabric.Line(
          [
            obj2Edges.left < obj1Edges.left ? obj2Edges.right : obj2Edges.left,
            (obj1Edges.top + obj1Edges.bottom) / 2,
            obj1Edges.left < obj2Edges.left ? obj1Edges.right : obj1Edges.left,
            (obj1Edges.top + obj1Edges.bottom) / 2,
          ],
          {
            stroke: "black",
            selectable: false,
            evented: false,
          }
        );
        const auxiliaryVerticalLine = new fabric.Line(
          [
            obj2Edges.left < obj1Edges.left ? obj2Edges.right : obj2Edges.left,
            (obj1Edges.top + obj1Edges.bottom) / 2,
            obj2Edges.left < obj1Edges.left ? obj2Edges.right : obj2Edges.left,
            (obj2Edges.top + obj2Edges.bottom) / 2,
          ],
          {
            stroke: "black",
            selectable: false,
            evented: false,
            strokeDashArray: [5, 5],
          }
        );
        canvas.add(auxiliaryVerticalLine);
        canvas.add(verticalLine);
      }

      const horizontalText = new fabric.Text(horizontalDistance.toFixed(2) + "px", {
        left: (horizontalLine1.x1 + horizontalLine2.x1) / 2 - 20,
        top: horizontalLine1.y1 + 5,
        fill: "red",
        fontSize: 10,
        selectable: false,
        evented: false,
      });
      if (horizontalDistance > 40) {
        horizontalText.set({
          fill: "	#CAE0A7",
        });
        let satisfiedImage = canvas.getObjects("image").find((img) => img.horizontalSatisfied);
        if (satisfiedImage) {
          satisfiedImage.set({
            left: (horizontalLine1.x1 + horizontalLine2.x1) / 2 - 35,
            top: horizontalLine1.y1 + 20,
          });
        } else {
          fabric.Image.fromURL(satisfied, function (oImg) {
            // removeSatisfied();
            removeHorizontalSatisfied();
            oImg.set({
              left: (horizontalLine1.x1 + horizontalLine2.x1) / 2 - 35,
              top: horizontalLine1.y1 + 20,
              selectable: false,
              evented: false,
              satisfied: true,
              horizontalSatisfied: true,
            });
            oImg.scaleToHeight(14);
            canvas.add(oImg);
          });
        }
        const horizontalTip = new fabric.Text("Satisfied", {
          left: (horizontalLine1.x1 + horizontalLine2.x1) / 2 - 20,
          top: horizontalLine1.y1 + 20,
          fill: "	#CAE0A7",
          fontSize: 14,
          selectable: false,
          evented: false,
        });

        canvas.add(horizontalTip);
      } else {
        // removeSatisfied();
        removeHorizontalSatisfied();
      }

      // const horizontalText = new fabric.Text(
      //   horizontalDistance.toFixed(2) + "px",
      //   {
      //     left: (verticalLine.x1 + verticalLine.x2) / 2,
      //     top: (verticalLine.y1 + verticalLine.y2) / 2,
      //     fill: "red",
      //     fontSize: 14,
      //     selectable: false,
      //     evented: false,
      //   }
      // );

      // if (horizontalDistance > 40) {
      //   const horizontalTip = new fabric.Text("Satisfied", {
      //     left: (verticalLine.x1 + verticalLine.x2) / 2,
      //     top: (verticalLine.y1 + verticalLine.y2) / 2 + 15,
      //     fill: "	#CAE0A7",
      //     fontSize: 14,
      //     selectable: false,
      //     evented: false,
      //   });
      //   canvas.add(horizontalTip);
      // }

      canvas.add(horizontalLine1);
      canvas.add(horizontalLine2);
      canvas.add(horizontalText);
    } else {
      removeSatisfied();
    }

    if (verticalDistance > 0 && verticalDistance < 100 && obj1.parent === obj2.parent) {
      const verticalLine1 = new fabric.Line(
        [
          (obj1Edges.left + obj1Edges.right) / 2 - 5,
          obj1Edges.top < obj2Edges.top ? obj1Edges.bottom : obj1Edges.top,
          (obj1Edges.left + obj1Edges.right) / 2 + 5,
          obj1Edges.top < obj2Edges.top ? obj1Edges.bottom : obj1Edges.top,
        ],
        {
          stroke: "black",
          selectable: false,
          evented: false,
        }
      );

      const verticalLine2 = new fabric.Line(
        [
          (obj2Edges.left + obj2Edges.right) / 2 - 5,
          obj2Edges.top < obj1Edges.top ? obj2Edges.bottom : obj2Edges.top,
          (obj2Edges.left + obj2Edges.right) / 2 + 5,
          obj2Edges.top < obj1Edges.top ? obj2Edges.bottom : obj2Edges.top,
        ],
        {
          stroke: "black",
          selectable: false,
          evented: false,
        }
      );

      if (verticalLine1.x1 === verticalLine2.x1) {
        const verticalLine = new fabric.Line(
          [
            (obj1Edges.left + obj1Edges.right) / 2,
            obj1Edges.top < obj2Edges.top ? obj1Edges.bottom : obj1Edges.top,
            (obj2Edges.left + obj2Edges.right) / 2,
            obj2Edges.top < obj1Edges.top ? obj2Edges.bottom : obj2Edges.top,
          ],
          {
            stroke: "black",
            selectable: false,
            evented: false,
          }
        );
        canvas.add(verticalLine);
      } else {
        const verticalLine = new fabric.Line(
          [
            (obj1Edges.left + obj1Edges.right) / 2,
            obj1Edges.top < obj2Edges.top ? obj1Edges.bottom : obj1Edges.top,
            (obj1Edges.left + obj1Edges.right) / 2,
            obj2Edges.top < obj1Edges.top ? obj2Edges.bottom : obj2Edges.top,
          ],
          {
            stroke: "black",
            selectable: false,
            evented: false,
          }
        );
        const auxiliaryVerticalLine = new fabric.Line(
          [
            (obj2Edges.left + obj2Edges.right) / 2,
            obj2Edges.top < obj1Edges.top ? obj2Edges.bottom : obj2Edges.top,
            (obj1Edges.left + obj1Edges.right) / 2,
            obj2Edges.top < obj1Edges.top ? obj2Edges.bottom : obj2Edges.top,
          ],
          {
            stroke: "black",
            selectable: false,
            evented: false,
            strokeDashArray: [5, 5],
          }
        );
        canvas.add(auxiliaryVerticalLine);
        canvas.add(verticalLine);
      }

      const verticalText = new fabric.Text(verticalDistance.toFixed(2) + "px", {
        left: verticalLine1.x1,
        top: (verticalLine1.y1 + verticalLine2.y1) / 2 - 20,
        fill: "red",
        fontSize: 10,
        selectable: false,
        evented: false,
        angle: 90,
      });

      if (verticalDistance > 40) {
        const verticalTip = new fabric.Text("Satisfied", {
          left: verticalLine1.x1 - 15,
          top: (verticalLine1.y1 + verticalLine2.y1) / 2 - 20,
          fill: "	#CAE0A7",
          fontSize: 14,
          selectable: false,
          evented: false,
          angle: 90,
        });
        verticalText.set({
          fill: "	#CAE0A7",
        });
        let satisfiedImage = canvas.getObjects("image").find((img) => img.verticalSatisfied);
        if (satisfiedImage) {
          satisfiedImage.set({
            left: verticalLine1.x1 - 30,
            top: (verticalLine1.y1 + verticalLine2.y1) / 2 - 35,
          });
        } else {
          // console.log(verticalDistance,123123123123);

          fabric.Image.fromURL(satisfied, function (oImg) {
            // removeSatisfied();
            removeVerticalSatisfied();
            oImg.set({
              left: verticalLine1.x1 - 30,
              top: (verticalLine1.y1 + verticalLine2.y1) / 2 - 35,
              selectable: false,
              evented: false,
              satisfied: true,
              verticalSatisfied: true,
            });
            oImg.scaleToHeight(14);
            canvas.add(oImg);
          });
        }
        canvas.add(verticalTip);
      } else {
        // removeSatisfied();
        removeVerticalSatisfied();
      }

      canvas.add(verticalLine1);
      canvas.add(verticalLine2);
      canvas.add(verticalText);
    }

    canvas.requestRenderAll();
  };

  const removeLineAndDistance = () => {
    const canvas = fabricCanvasRef.current;
    canvas.getObjects("line").forEach((line) => canvas.remove(line));
    canvas.getObjects("text").forEach((text) => canvas.remove(text));

    canvas.requestRenderAll();
  };

  const removeSatisfied = () => {
    const canvas = fabricCanvasRef.current;
    canvas.getObjects("image").forEach((img) => {
      if (img.satisfied) {
        canvas.remove(img);
      }
    });
  };

  const removeVerticalSatisfied = () => {
    const canvas = fabricCanvasRef.current;
    canvas.getObjects("image").forEach((img) => {
      if (img.verticalSatisfied) {
        canvas.remove(img);
      }
    });
  };

  const removeHorizontalSatisfied = () => {
    const canvas = fabricCanvasRef.current;
    canvas.getObjects("image").forEach((img) => {
      if (img.horizontalSatisfied) {
        canvas.remove(img);
      }
    });
  };

  const handleMoving = (e) => {
    const canvas = fabricCanvasRef.current;
    const movingObject = e.target;

    // 计算位移差
    const objectId = movingObject.id || movingObject.name;
    const lastPos = lastPositionRef.current[objectId];
    
    if (lastPos) {
      const deltaX = movingObject.left - lastPos.left;
      const deltaY = movingObject.top - lastPos.top;

      // 如果是画布（矩形且有id属性），移动其所有子对象
      if (movingObject.type === "rect" && movingObject.id) {
        canvas.getObjects().forEach((obj) => {
          if (obj !== movingObject) {
            // 移动属于该画布的功能分区（root属性等于画布id）
            if (obj.root === movingObject.id) {
              obj.set({
                left: obj.left + deltaX,
                top: obj.top + deltaY,
              });
              obj.setCoords();
            }
            // 移动属于该画布的直接子对象（parent属性等于画布name）
            else if (obj.parent === movingObject.name) {
              obj.set({
                left: obj.left + deltaX,
                top: obj.top + deltaY,
              });
              obj.setCoords();
            }
          }
        });
      }
      // 如果是功能分区（group），移动其所有子对象
      else if (movingObject.type === "group" && movingObject.name) {
        canvas.getObjects().forEach((obj) => {
          if (obj !== movingObject && obj.parent === movingObject.name) {
            obj.set({
              left: obj.left + deltaX,
              top: obj.top + deltaY,
            });
            obj.setCoords();
          }
        });
      }
    }

    // 更新当前位置
    lastPositionRef.current[objectId] = {
      left: movingObject.left,
      top: movingObject.top,
    };

    // 限制子对象在父对象内部移动
    if (movingObject.parent) {
      let parentGroup = canvas.getObjects().find((obj) => obj.name === movingObject.parent);
      if (parentGroup) {
        if (movingObject.left < parentGroup.left) {
          movingObject.left = parentGroup.left;
        }
        if (movingObject.top < parentGroup.top) {
          movingObject.top = parentGroup.top;
        }
        if (
          movingObject.left + movingObject.width * movingObject.scaleX >
          parentGroup.left + parentGroup.width * parentGroup.scaleX
        ) {
          movingObject.left =
            parentGroup.left +
            parentGroup.width * parentGroup.scaleX -
            movingObject.width * movingObject.scaleX;
        }
        if (
          movingObject.top + movingObject.height * movingObject.scaleY >
          parentGroup.top + parentGroup.height * parentGroup.scaleY
        ) {
          movingObject.top =
            parentGroup.top +
            parentGroup.height * parentGroup.scaleY -
            movingObject.height * movingObject.scaleY;
        }
      }
    }

    let closestObject = null;
    let minDistanceInfo = {
      horizontalDistance: Infinity,
      verticalDistance: Infinity,
      obj1Edges: {},
      obj2Edges: {},
    };

    canvas.getObjects().forEach((obj) => {
      if (obj !== movingObject && obj.name === "image") {
        const distanceInfo = calculateEdgeDistance(movingObject, obj);

        if (
          distanceInfo.horizontalDistance < minDistanceInfo.horizontalDistance ||
          distanceInfo.verticalDistance < minDistanceInfo.verticalDistance
        ) {
          minDistanceInfo = distanceInfo;
          closestObject = obj;
        }
      }
    });

    if (
      closestObject &&
      (minDistanceInfo.horizontalDistance <= 100 || minDistanceInfo.verticalDistance <= 100)
    ) {
      drawLineAndDistance(movingObject, closestObject, minDistanceInfo);
    } else {
      removeLineAndDistance();
    }
  };

  const rgbToLuminance = (rgb) => {
    const { r, g, b } = rgb;
    return 0.2126 * (r / 255) + 0.7152 * (g / 255) + 0.0722 * (b / 255);
  };

  const calculateContrast = (color1, color2) => {
    const luminance1 = rgbToLuminance(color1);
    const luminance2 = rgbToLuminance(color2);

    const L1 = Math.max(luminance1, luminance2);
    const L2 = Math.min(luminance1, luminance2);

    const contrastRatio = (L1 + 0.05) / (L2 + 0.05);
    return contrastRatio;
  };

  useEffect(() => {
    const canvas = fabricCanvasRef.current;
    if (canvas) {
      let activeArr = canvas.getActiveObjects();
      if (activeArr.length === 1) {
        // console.log(activeArr[0], "activeArr[0]");
        activeArr[0].set({
          cars: cars,
        });
      }
    }
  }, [cars]);

  useEffect(() => {
    const canvas = fabricCanvasRef.current;
    if (canvas && text) {
      let activeObj = canvas?.getActiveObject();
      // const handleTextMouseDown = (opt) => {
      // setText(false);
      // setUnactive(true);
      // let pointer = canvas.getPointer(opt.e);
      
      setLayerCount((prevLayerCount) => {
        const nextIndex = getNextIndex(prevLayerCount);
        
        let textBox = new fabric.Textbox(`请输入文本`, {
          parent: activeObj?.name,
          left: activeObj?.left + 20,
          top: activeObj?.top + 20,
          charSpacing: 0,
          fontSize: 24,
          root: activeObj?.root,
          apiName: "text",
          lineHeight: 1,
          fontWeight: "normal",
          fill: "#000",
          fontFamily: "宋体",
          textAlign: "left",
          opacity: 1,
          opacityOriginal: 1,
          width: 200,
          padding: 0,
          index: {
            index: nextIndex,
            visiable: true,
            parentIndex: activeObj?.index.index,
          },
          name: "text",
          layerType: "text",
          cars: {
            carType: "",
            numberType: "",
          },
          dynamic: false,
          customTypeName: "",
          category: "",
        });
        canvas.add(textBox);
        // canvas.setActiveObject(textBox);
        // textBox.enterEditing();

        textBox["setControlVisible"]("ml", false);
        textBox["setControlVisible"]("mb", false);
        textBox["setControlVisible"]("mr", false);
        textBox["setControlVisible"]("mt", false);

        textBox.on("changed", () => {
          // console.log(textBox,'textBox');
          // if(textBox.text.length > 120){
          //   // message.error('Failed！the maximum length of text is 120')
          //   debouncedScalingMessage('error','Failed！the maximum length of text is 120',1);
          //   textBox.set({
          //     text: textBox.text.slice(0,120)
          //   })
          // }
          setLayerCount((prevLayerCount) => {
            return prevLayerCount.map((layer) => {
              return layer.index === textBox.index.index
                ? {
                    ...layer,
                    fileName: textBox.text,
                  }
                : layer;
            });
          });
          textBox.set({
            width: textBox.calcTextWidth(),
            height: textBox.calcTextHeight(),
          });
          canvas.renderAll();
        });

        return [
          ...prevLayerCount,
          {
            index: nextIndex,
            visiable: true,
            layerType: "text",
            opacity: 1,
            parent: activeObj?.name,
            root: activeObj?.root,
            type: "文本",
            apiName: "text",
            fileName: textBox.text,
            color: textBox.fill,
          },
        ];
      });
      // };

      // if (text) {
      //   canvas.on("mouse:down", handleTextMouseDown);
      // } else {
      //   canvas.off("mouse:down", handleTextMouseDown);
      // }

      // return () => {
      //   canvas.off("mouse:down", handleTextMouseDown);
      // };
      setText(false);
    }
  }, [text]);

  useEffect(() => {
    const canvas = fabricCanvasRef.current;
    if (canvas && fontStyle) {
      let activeArr = canvas.getActiveObjects();
      if (activeArr.length > 0) {
        activeArr.forEach((item) => {
          if (item.name === "text") {
            const currentFillColor = fontStyle.fill || "#000";
            item.set({
              fill: fontStyle.fill || "#000",
            });
            setLayerCount((prevLayerCount) => {
              return prevLayerCount.map((layer) => {
                return layer.index === item.index.index
                  ? {
                      ...layer,
                      color: fontStyle.fill || "#000",
                    }
                  : layer;
              });
            });
            // if (currentFillColor !== prevFillColor) {
            //   // console.log(canvasStyle.backgroundColor, "canvasStyle.backgroundColor");
            //   // let fontRgb = set16ToRgb(currentFillColor);
            //   let bgRgb = set16ToRgb(canvasStyle.backgroundColor);
            //   const contrastValue = calculateContrast(fontRgb, bgRgb);
            //   if(contrastValue<4.5){
            //     // message.error(`Failed!The contrast ratio between the text color and the background color is ${contrastValue.toFixed(2)}, which is less than our recommended value of 4.5`);
            //     debouncedScalingMessage('error',`Failed!The contrast ratio between the text color and the background color is ${contrastValue.toFixed(2)}, which is less than our recommended value of 4.5`,1);
            //   }else{
            //     // message.open({
            //     //   type:'success',
            //     //   content:`Satisfied！The contrast ratio between the text color and the background color is ${contrastValue.toFixed(2)}`,
            //     //   style:{
            //     //     opacity:0.3
            //     //   }
            //     // });
            //     debouncedScalingMessage('success',`Satisfied！The contrast ratio between the text color and the background color is ${contrastValue.toFixed(2)}`,0.3);
            //   }
            //   setPrevFillColor(currentFillColor);
            // }
          }
          if (item.type === "rect") {
            item.set({
              fill: fontStyle.fill || item.fill,
            });
            setLayerCount((prevLayerCount) => {
              return prevLayerCount.map((layer) => {
                return layer.index === item.index.index
                  ? {
                      ...layer,
                      backgroundColor: fontStyle.fill || item.fill,
                    }
                  : layer;
              });
            });
          } else {
            item.set({
              fontSize: fontStyle.fontSize || item.fontSize,
              fontWeight: fontStyle.fontWeight || item.fontWeight,
              fontFamily: fontStyle.fontFamily || item.fontFamily,
              charSpacing: fontStyle.charSpacing || item.charSpacing,
              lineHeight: fontStyle.lineHeight || item.lineHeight,
              opacity: fontStyle.opacity || item.opacity,
              opacityOriginal: fontStyle.opacity,
              index: {
                ...item.index,
                opacity: fontStyle.opacity || item.opacity,
              },
            });
          }
        });
        canvas.renderAll();
        //更新layerCount
        setLayerCount((prevLayerCount) => {
          return prevLayerCount.map((layer) => {
            return activeArr.some((item) => layer.index === item.index.index)
              ? {
                  ...layer,
                  opacity: fontStyle.opacity,
                }
              : layer;
          });
        });
      }
    }
  }, [fontStyle]);

  const set16ToRgb = (str) => {
    var reg = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;
    if (!reg.test(str)) {
      return;
    }
    let newStr = str.toLowerCase().replace(/\#/g, "");
    let len = newStr.length;
    if (len == 3) {
      let t = "";
      for (var i = 0; i < len; i++) {
        t += newStr.slice(i, i + 1).concat(newStr.slice(i, i + 1));
      }
      newStr = t;
    }
    let arr = [];
    for (var i = 0; i < 6; i = i + 2) {
      let s = newStr.slice(i, i + 2);
      arr.push(parseInt("0x" + s));
    }
    return { r: arr[0], g: arr[1], b: arr[2] };
  };

  useEffect(() => {
    const canvas = fabricCanvasRef.current;
    const handleKeyDown = (e) => {
      if (canvas) {
        // 检查是否在输入框中，如果是则不执行快捷键
        const target = e.target;
        const isInputField = target.tagName === "INPUT" || 
                            target.tagName === "TEXTAREA" || 
                            target.isContentEditable;

        // Ctrl+Z 撤销
        if (e.ctrlKey && e.key === "z" && !isInputField) {
          e.preventDefault();
          undo();
          return;
        }

        // Ctrl+Y 恢复
        if (e.ctrlKey && e.key === "y" && !isInputField) {
          e.preventDefault();
          redo();
          return;
        }

        // Ctrl+C 复制
        if (e.ctrlKey && e.key === "c" && !isInputField) {
          e.preventDefault();
          copyObject();
          return;
        }

        // Ctrl+V 粘贴
        if (e.ctrlKey && e.key === "v" && !isInputField) {
          e.preventDefault();
          pasteObject();
          return;
        }

        let activeArr = canvas.getActiveObjects();
        let objs = canvas.getObjects();
        if (e.key === "Delete") {
          // 判断当前删除的对象类型是否为rect
          if (activeArr[0]?.type === "rect") {
            // 获取当前canvas中所有rect类型的对象
            const rectObjs = objs.filter((obj) => obj.type === "rect");
            // 如果只有一个rect，则不能删除
            if (rectObjs.length === 1) {
              message.warning("至少保留一个画布！");
              return;
            }
          }
          activeArr.forEach((item) => {
            // 如果删除的是画布（rect），则一并删除root为该画布id的对象
            if (item.type === "rect" && item.id) {
              // 获取所有root为该画布id的对象
              const objsToRemove = canvas.getObjects().filter((obj) => obj.root === item.id);
              objsToRemove.forEach((obj) => {
                canvas.remove(obj);
              });
            }
            canvas.remove(item);
          });
          if (customFeatures.find((item) => item.label === activeArr[0]?.name)) {
            setCustomFeatures(customFeatures.filter((item) => item.label !== activeArr[0]?.name));
            localStorage.setItem(
              "customFeatures",
              JSON.stringify(customFeatures.filter((item) => item.label !== activeArr[0]?.name))
            );
          }

          setLayerCount((prevLayerCount) => {
            return prevLayerCount.filter((layer) => {
              return !activeArr.some((item) => layer.index === item.index.index);
            });
          });

          canvas.discardActiveObject();
          canvas.requestRenderAll();
          setFontStyleBtn([]);
          setFontStyle({
            index: 0,
          });

          // 删除操作后延迟保存历史记录
          setTimeout(() => {
            saveHistory();
          }, 100);
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  });

  useEffect(() => {
    const canvas = fabricCanvasRef.current;
    if (canvas) {
      let activeArr = canvas.getActiveObjects();
      if (activeArr.length > 0) {
        activeArr.forEach((item) => {
          if (fontStyleBtn.includes(0)) {
            item.set({ fontStyle: "italic" });
          } else {
            item.set({ fontStyle: "normal" });
          }
          if (fontStyleBtn.includes(2)) {
            item.set({ underline: true });
          } else {
            item.set({ underline: false });
          }
          if (fontStyleBtn.includes(3)) {
            item.set({ linethrough: true });
          } else {
            item.set({ linethrough: false });
          }
          if (fontStyleBtn.includes(3)) {
            item.set({ textTransform: "uppercase" });
          } else {
            item.set({ textTransform: "none" });
          }
        });
        canvas.renderAll();
      }
    }
  }, [fontStyleBtn]);

  useEffect(() => {
    const canvas = fabricCanvasRef.current;
    if (canvas) {
      let activeArr = canvas.getActiveObjects();
      if (activeArr.length > 0 && activeArr.length < 2) {
        activeArr[0].set({
          dynamic: dynamic,
          customTypeName: customTypeName,
          category: category,
          iconExclusivity: iconExclusivity,
        });
      }
    }
  }, [dynamic, customTypeName, category, iconExclusivity]);

  useEffect(() => {
    const canvas = fabricCanvasRef.current;
    getCustomTypeName();
    if (canvas) {
      let objs = canvas.getObjects();
      const layer = layerCount.find((item) => item.index === layerNow);
      const background = objs.find((item) => item.id === layer?.root);
      if (objs.length > 0 && background) {
        objs.forEach((item) => {
          if (item.index?.index === layerNow && background) {
            // console.log(item, "item in useEffect layerNow change");

            canvas.setActiveObject(item);
            canvas.requestRenderAll();
            setImageStyles({
              left: Math.round((item?.left - background.left) * 100) / 100,
              top: Math.round((item?.top - background.top) * 100) / 100,
              width: Math.round(item?.width * 100 * item.scaleX) / 100,
              height: Math.round(item?.height * 100 * item.scaleY) / 100,
              angle: Math.round(item?.angle * 100) / 100 || 0,
              opacity: item?.opacity * 100 || item.opacityOriginal * 100,
            });
            setFontStyle({
              fontSize: item.fontSize,
              fontWeight: item.fontWeight,
              fontFamily: item.fontFamily,
              charSpacing: item.charSpacing,
              lineHeight: item.lineHeight,
              index: item.index,
              opacity: item.opacity,
              fill: item.fill || "#000",
            });
            setFontStyleBtn([
              item.fontStyle === "italic" ? 0 : -1,
              item.underline ? 2 : -1,
              item.linethrough ? 3 : -1,
            ]);
            if (item.cars) {
              setShowData(true);
              setCars({
                carType: item.cars.carType,
                numberType: item.cars.numberType,
              });
              setShowFont(true);
            } else {
              setShowData(false);
              setShowFont(false);
            }
            if (item.hasOwnProperty("dynamic") || item.customTypeName) {
              // console.log(111);
              setShowDynamic(true);
              setDynamic(item.dynamic);
              setIconExclusivity(item.iconExclusivity);
              setCustomTypeName(item.customTypeName);
              setCategory(item.category);
            } else {
              setShowDynamic(false);
            }
          }
        });
      }
    }
    // console.log(layerCount);

    const currentLayer = layerCount.find((item) => item.index === layerNow);
    if (currentLayer && currentLayer.type === "功能分区") {
      setShowZone(true);
    } else {
      setShowZone(false);
    }
  }, [layerNow]);

  useEffect(() => {
    const canvas = fabricCanvasRef.current;
    // console.log(imageStyles, "imageStyles");

    if (canvas && imageStyles !== imageStylesInit) {
      let activeObj = canvas?.getActiveObject();
      let objs = canvas.getObjects();
      if (activeObj && activeObj.index) {
        const background = objs.find((item) => item.id === activeObj.root);
        activeObj.set({
          scaleX: imageStyles.width / activeObj.width,
          scaleY: imageStyles.height / activeObj.height,
          angle: imageStyles.angle,
          opacity: imageStyles.opacity / 100,
          opacityOriginal: imageStyles.opacity / 100,
        });
        if (background) {
          activeObj.set({
            left: imageStyles.left + background?.left,
            top: imageStyles.top + background?.top,
            opacity: imageStyles.opacity / 100,
            opacityOriginal: imageStyles.opacity / 100,
          });
        }
        setLayerCount((prevLayerCount) => {
          return prevLayerCount.map((layer) => {
            return layer.index === activeObj.index.index
              ? {
                  ...layer,
                  opacity: imageStyles.opacity / 100,
                }
              : layer;
          });
        });
        canvas.renderAll();
      }
    }
  }, [imageStyles]);

  useEffect(() => {
    const canvas = fabricCanvasRef.current;

    if (canvas && JSON.stringify(newZone) !== "{}") {
      let objs = canvas.getObjects();
      const currentLayer = layerCount.find((item) => item.index === layerNow);
      // 计算正确的 rootId：当前选中是画布则用其 id，否则使用其 root
      const rootId = currentLayer
        ? currentLayer.type === "画布"
          ? currentLayer.id
          : currentLayer.root
        : undefined;

      if (!rootId) {
        return;
      }

      let background = objs.find((item) => item.id === rootId);
      if (!background) {
        return;
      }

      // 若同一画布(root)下已存在同名功能分区，则不重复新增
      const hasSameZone =
        objs.some(
          (obj) => obj.type === "group" && obj.name === newZone.key && obj.root === rootId
        ) ||
        layerCount.some(
          (l) => l.type === "功能分区" && l.name === newZone.key && l.root === rootId
        );
      if (hasSameZone) {
        return;
      }

      setLayerCount((prevLayerCount) => {
        const nextIndex = getNextIndex(prevLayerCount);

        let rect = new fabric.Rect({
          left: background.left + 50,
          top: background.top + 50,
          width: 300,
          height: 300,
          fill: "#56A5EF",
        });
        let text = new fabric.Textbox(newZone?.key, {
          left: background.left + 50,
          top: background.top + 50,
          fill: "black",
          fontSize: 18,
          width: 200,
        });
        let group = new fabric.Group([rect, text], {
          name: newZone.key,
          opacity: 0.3,
          opacityOriginal: 0.3,
          root: rootId,
          apiName: "functionalZone",
          index: {
            index: nextIndex,
            visiable: true,
            opacity: 0.3,
          },
        });
        canvas.add(group);
        handleGroupScaling(group);

        setLayerNow(nextIndex);

        return [
          ...prevLayerCount,
          {
            index: nextIndex,
            visiable: true,
            opacity: 0.3,
            backgroundColor: "#56A5EF",
            name: newZone.key,
            root: rootId,
            type: "功能分区",
            apiName: "functionalZone",
            tempName: newZone.key,
          },
        ];
      });
    }
  }, [newZone]);

  useEffect(() => {
    // console.log(layerCount, "layerCount");

    const canvas = fabricCanvasRef.current;
    if (canvas) {
      let objs = canvas.getObjects();
      let shouldDiscardActiveObject = false;
      const currentActiveObject = canvas.getActiveObject();

      // 处理所有对象的显示/隐藏状态
      objs.forEach((item) => {
        const layer = layerCount.find((layer) => layer.index === item.index?.index);
        if (layer) {
          if (layer.visiable) {
            item.set({
              opacity: item.opacityOriginal,
              selectable: true,
              evented: true,
            });
            if (item.index?.index === layerNow) {
              canvas.setActiveObject(item);
            }
          } else {
            item.set({ opacity: 0, selectable: false, evented: false });
            // 检查当前激活的对象是否就是这个被隐藏的对象
            if (currentActiveObject && currentActiveObject.index?.index === item.index?.index) {
              shouldDiscardActiveObject = true;
            }
          }
        }
      });

      // 只有当前激活的对象被隐藏时，才取消选中
      if (shouldDiscardActiveObject) {
        canvas.discardActiveObject();
      }

      canvas.requestRenderAll();
    }
  }, [layerCount]);

  useEffect(() => {
    const canvas = fabricCanvasRef.current;

    if (canvas && imgs.length > 0) {
      let activeObj = canvas?.getActiveObject();
      // console.log("showIcons",showIcons);
      if (!showIcons) {
        setLayerCount((prevLayerCount) => {
          const nextIndex = getNextIndex(prevLayerCount);
          
          fabric.Image.fromURL(
            imgs[0].url,
            (oImg) => {
              oImg.set({
                parent: activeObj?.layerType === "image" ? activeObj?.parent : activeObj?.name,
                left: activeObj?.left + 50,
                top: activeObj?.top + 50,
                selectable: true,
                evented: true,
                fileName: imgs[0].name,
                apiName: "image",
                index: {
                  index: nextIndex,
                  visiable: true,
                  parentIndex:
                    activeObj?.layerType === "image"
                      ? activeObj?.index.parentIndex
                      : activeObj?.index.index,
                },
                name: "image",
                root: activeObj?.root,
                duplicateIconCategoryId: imgs[0]?.duplicateIconCategoryId,
                duplicateIcons: imgs || [],
                opacity: 1,
                opacityOriginal: 1,
                scaleX: 30 / Math.max(oImg.width, oImg.height),
                scaleY: 30 / Math.max(oImg.width, oImg.height),
                layerType: "image",
                dynamic: false,
                iconExclusivity: false,
                customTypeName: "",
                category: "",
                lockScalingFlip: true,
                minScaleLimit: 30 / Math.max(oImg.width, oImg.height),
              });

              canvas.add(oImg);
              canvas.bringToFront(oImg);
              canvas.renderAll();
              
              setLayerNow(nextIndex);
            },
            { crossOrigin: "anonymous" }
          );
          
          return [
            ...prevLayerCount,
            {
              index: nextIndex,
              visiable: true,
              layerType: "image",
              opacity: 1,
              parent: activeObj?.layerType === "image" ? activeObj?.parent : activeObj?.name,
              root: activeObj?.root,
              type: "图标",
              apiName: "image",
              fileName: imgs[0].name,
              duplicateIconCategoryId: imgs[0]?.duplicateIconCategoryId,
              duplicateIcons: imgs || [],
            },
          ];
        });
      } else {
        let activeImage = canvas.getActiveObject();
        if (activeImage && activeImage.type === "image") {
          activeImage.setSrc(imgs[0].url, () => {
            activeImage.set({
              fileName: imgs[0].name,
            });
            canvas.renderAll();
          });
        }

        setLayerCount((prevLayerCount) => {
          return prevLayerCount.map((layer) => {
            if (layer.index === activeImage?.index?.index) {
              return {
                ...layer,
                fileName: imgs[0].name,
              };
            }
            return layer;
          });
        });
      }
      setImgs([]);
    }
  }, [imgs]);

  useEffect(() => {
    let canvas = fabricCanvasRef.current;
    if (canvas) {
      if (save) {
        exportToJsonFile();
        setSave(false);
      }
    }
  }, [save]);

  useEffect(() => {
    let name = Object.entries(checkObj)
      .filter(([key, value]) => value)
      .map(([key, value]) => key)
      .join("+");

    let bgs = importAll(require.context("../imgs", false, /\.(png)$/));
    let canvas = fabricCanvasRef.current;

    if (canvas) {
      let bgImage = canvas.getObjects().find((item) => item.name === "bgImage");
      if (bgImage) {
        let imageUrl = bgs[`${name}.png`] || bg1;
        fabric.Image.fromURL(imageUrl, (oImg) => {
          oImg.set({
            selectable: false,
            evented: false,
            name: "bgImage",
            left: 0,
            top: 0,
          });
          oImg.scaleToWidth(2872);
          oImg.scaleToHeight(1074);
          bgImage.set({
            opacity: 0,
          });

          canvas.add(oImg);
          canvas.sendToBack(oImg);

          oImg.set({
            opacity: 1,
          });

          canvas.renderAll();

          canvas.remove(bgImage);
        });
      }
    }
  }, [checkObj]);

  useEffect(() => {
    const canvas = fabricCanvasRef.current;
    if (canvas) {
      let objs = canvas.getObjects();
      // console.log(objs, "objsssss");

      objs.forEach((item) => {
        if (item.index?.index === newDuplicateIcons.index) {
          item.set({
            duplicateIcons: newDuplicateIcons.duplicateIcons,
          });
        }
      });
      canvas.requestRenderAll();
    }
  }, [newDuplicateIcons]);

  const handleClick = (opt) => {
    getCustomTypeName();
    const canvas = fabricCanvasRef.current;
    if (canvas) {
      let activeArr = canvas.getActiveObjects();
      let objs = canvas.getObjects();
      // console.log(objs, "objs");
      // console.log(customFeatures, "customFeatures");
      
      // 如果没有选中对象或选中多个对象，返回
      if (activeArr.length === 0) return;
      if (activeArr.length > 1) {
        // 多选时，只显示基本信息，不设置详细属性
        setShowZone(false);
        setShowData(false);
        setShowDynamic(false);
        setShowFont(false);
        return;
      }
      
      // 单个对象选中时，检查是否有 index 属性
      if (!activeArr[0]?.index) {
        console.log("选中的对象没有 index 属性:", activeArr[0]);
        return;
      }
      
      const layer = layerCount.find((layer) => layer.index === activeArr[0]?.index.index);
      let background = objs.find((item) => item.id === layer?.root);
      // console.log(background, layer, "background");

      setLayerNow(activeArr[0]?.index.index);
      if (activeArr[0]?._objects && background && activeArr[0]?.index && background.index) {
        setActiveSecondKey(activeArr[0].index.index.toString());
        setActiveKey(background.index.index);

        // setActiveKey(activeArr[0].index.parentIndex.toString());
        // setShowZone(true);
        // console.log(activeArr[0], "activeArr[0] in _objects", background);

        setImageStyles({
          left: Math.round((activeArr[0].left - background.left) * 100) / 100,
          top: Math.round((activeArr[0].top - background.top) * 100) / 100,
          width: Math.round(activeArr[0].width * 100 * activeArr[0].scaleX) / 100,
          height: Math.round(activeArr[0].height * 100 * activeArr[0].scaleY) / 100,
          angle: Math.round(activeArr[0].angle * 100) / 100 || 0,
          opacity: activeArr[0].opacity * 100 || activeArr[0].opacityOriginal * 100,
        });
      }
      // else {

      //   setShowZone(false);
      // }
      if (!("root" in activeArr[0]) && background && activeArr.length < 2 && activeArr[0]?.index) {
        setActiveKey(activeArr[0].index.index);
        setShowFont(false);
        setShowData(false);
        setShowDynamic(false);
        setImageStyles({
          left: Math.round(activeArr[0].left * 100) / 100,
          top: Math.round(activeArr[0].top * 100) / 100,
          width: Math.round(activeArr[0].width * 100 * activeArr[0].scaleX) / 100,
          height: Math.round(activeArr[0].height * 100 * activeArr[0].scaleY) / 100,
          angle: Math.round(activeArr[0].angle * 100) / 100 || 0,
          opacity: activeArr[0].opacity * 100 || activeArr[0].opacityOriginal * 100,
        });
        setFontStyleBtn([]);
        setFontStyle({
          index: 0,
          opacity: activeArr[0].opacity,
        });
        // setLayerNow(0);
      } else if (activeArr[0]?.name === "text" && activeArr.length < 2 && background && activeArr[0]?.index && background.index) {
        setActiveSecondKey(activeArr[0].index.parentIndex.toString());
        setActiveKey(background.index.index);
        setShowFont(true);
        setShowData(true);
        setShowDynamic(true);
        setDynamic(activeArr[0].dynamic || false);
        setIconExclusivity(activeArr[0].iconExclusivity || false);
        setCustomTypeName(activeArr[0].customTypeName || "");
        setCategory(activeArr[0].category || "");
        setFontStyle({
          fontSize: activeArr[0].fontSize,
          fontWeight: activeArr[0].fontWeight,
          fontFamily: activeArr[0].fontFamily,
          charSpacing: activeArr[0].charSpacing,
          lineHeight: activeArr[0].lineHeight,
          index: activeArr[0].index,
          opacity: activeArr[0].opacity,
          fill: activeArr[0].fill || "#000",
        });
        setFontStyleBtn([
          activeArr[0].fontStyle === "italic" ? 0 : -1,
          activeArr[0].underline ? 2 : -1,
          activeArr[0].linethrough ? 3 : -1,
        ]);
        setCars(activeArr[0].cars);
        // setLayerNow(activeArr[0]?.index.index);
        canvas.bringToFront(activeArr[0]);
      } else if (activeArr[0]?.name === "image" && background && activeArr.length < 2 && activeArr[0]?.index && background.index) {
        setShowFont(false);
        setActiveSecondKey(activeArr[0].index.parentIndex.toString());
        setActiveKey(background.index.index);
        setImageStyles({
          left: Math.round((activeArr[0].left - background.left) * 100) / 100,
          top: Math.round((activeArr[0].top - background.top) * 100) / 100,
          width: Math.round(activeArr[0].width * 100 * activeArr[0].scaleX) / 100,
          height: Math.round(activeArr[0].height * 100 * activeArr[0].scaleY) / 100,
          angle: Math.round(activeArr[0].angle * 100) / 100 || 0,
          opacity: activeArr[0].opacity * 100 || activeArr[0].opacityOriginal * 100,
        });
        setShowIconExclusive(true);
        setShowData(false);
        setShowDynamic(true);
        setFontStyleBtn([]);
        setFontStyle({
          index: activeArr[0].index,
          opacity: activeArr[0].opacity,
        });
      } else {
        // setShowZone(false);
        setShowData(false);
        setShowDynamic(false);
        setShowFont(false);
        return;
      }
    }
  };
  // 获取所有元素customTypeName
  const getCustomTypeName = () => {
    const canvas = fabricCanvasRef.current;
    if (canvas) {
      let objs = canvas.getObjects();
      let customTypeNameArr = [];
      objs.forEach((item) => {
        if (item.customTypeName) {
          customTypeNameArr.push(item.customTypeName);
        }
      });
      setCustomTypeNameArr(customTypeNameArr);
    }
  };

  const exportToJsonFile = async () => {
    // setOpen(true);
    const canvas = fabricCanvasRef.current;
    if (canvas) {
      let json = canvas.toJSON([
        "name",
        "selectable",
        "evented",
        "index",
        "opacityOriginal",
        "layerType",
        "dynamic",
        "cars",
        "customTypeName",
        "category",
        "iconExclusivity",
        "parent",
        "apiName",
        "fileName",
        "categoryId",
        "duplicateIconCategoryId",
        "duplicateIcons",
        "root",
        "id",
      ]);
      const id = JSON.parse(localStorage.getItem("projectList")).find(
        (item) => item.name === name
      )?.id;
      
      // 等待保存到后端完成
      try {
        if (id) {
          json.id = id;
          await saveProjectRequest({
            id: id,
            data: JSON.stringify(json),
          });
        } else {
          await createProjectRequest({
            name: name,
            data: JSON.stringify(json),
          });
        }
      } catch (error) {
        console.error("保存到后端失败:", error);
        return; // 保存失败则不继续执行
      }
      
      json.objects.forEach((item, index) => {
        //rect应该为当前item的root对应的rect
        let rect = json.objects.find((obj) => obj.id === item.root);

        if (index > 0) {
          const rectWidth = rect.width * rect.scaleX;
          const rectHeight = rect.height * rect.scaleY;

          if (item.type === "rect") {
            item.percentageX = (item.left - rect.left) / rectWidth;
            item.percentageY = (item.top - rect.top) / rectHeight;
          } else if (item.type === "textbox") {
            item.percentageX = (item.left - rect.left) / rectWidth;
            item.percentageY = (item.top - rect.top) / rectHeight;
            item.spaceLeftX = 8.99 * item.scaleX;
            item.spaceRightX = 8.56 * item.scaleX;
            item.spaceTopY = 3.63 * item.scaleY;
            item.spaceBottomY = 5.7 * item.scaleY;
          } else if (item.type === "image") {
            item.percentageX = (item.left - rect.left) / rectWidth;
            item.percentageY = (item.top - rect.top) / rectHeight;
          }
        }
      });

      let blob = new Blob([JSON.stringify(json, null, 2)], {
        type: "application/json",
      });
      setBlob(blob);

      // 根据shouldDownloadJson状态决定是否下载json文件
      if (shouldDownloadJson) {
        saveAs(blob, `${name}.json`);
      }
      // 重置为默认值（下次保存时会下载）
      setShouldDownloadJson(true);
 
      let message = { ...json };
      message.objects = message.objects
        .map((item) => {
          if (item.type === "image" && item.name !== "bgImage" && item.name !== "image") {
            return null;
          } else if (item.name === "bgImage") {
            return { name: item.name, width: item.width, height: item.height };
          }
          return item;
        })
        .filter((item) => item !== null);
      // setTransferMessage(message);

      // 等待上传到智翎云境完成
      await handleConfirm(message);
    }
  };

  const exportImage = async (message) => {
    await Promise.all(
      message.objects.map(async (item) => {
        if (item.type === "image" && item.src) {
          return new Promise((resolve) => {
            let img = new Image();
            img.src = item.src;
            img.crossOrigin = "Anonymous";
            img.onload = function () {
              let canvas = document.createElement("canvas");
              let ctx = canvas.getContext("2d");
              canvas.width = img.width;
              canvas.height = img.height;
              ctx.drawImage(img, 0, 0, img.width, img.height);
              item.src = canvas.toDataURL();
              resolve();
            };
          });
        }
      })
    );
  };

  const saveCanvas = () => {
    const canvas = fabricCanvasRef.current;
    let canvasArr = localStorage.getItem("canvasArr")
      ? JSON.parse(localStorage.getItem("canvasArr"))
      : [];
    if (canvas) {
      let json = canvas.toJSON([
        "name",
        "selectable",
        "evented",
        "index",
        "opacityOriginal",
        "layerType",
        "dynamic",
        "cars",
        "customTypeName",
        "category",
        "iconExclusivity",
        "parent",
        "apiName",
        "fileName",
        "categoryId",
        "duplicateIconCategoryId",
        "duplicateIcons",
        "root",
        "id",
      ]);
      json.name = name;
      json = { ...json, checkObj: { ...checkObj } };

      const existingCanvasIndex = canvasArr.findIndex((item) => item.name === name);
      if (existingCanvasIndex !== -1) {
        canvasArr[existingCanvasIndex].objects = json.objects;
        canvasArr[existingCanvasIndex].checkObj = json.checkObj;
      } else {
        canvasArr.push(json);
      }
      localStorage.setItem("canvasArr", JSON.stringify(canvasArr));
    }
  };

  useEffect(() => {
    // console.log(changeName, "监听到changeName变化");
    if (changeName) {
      if (fabricCanvasRef.current && fabricCanvasRef.current.id) {
        localStorage.setItem("projectId", fabricCanvasRef.current.id);
      }
      saveCanvas();
      setChangeName(false);
    }
  }, [changeName]);

  // 上传到智翎云境
  const handleConfirm = async (messageData) => {
    try {
      await exportImage(messageData);
      let uploadMessage = { ...messageData, ...checkObj };

      const response = await fetch("https://hud-ui-api.dinglantech.com/publish", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ message: uploadMessage, save: true, channel: "123456" }),
      });
      
      await response.json();

      // 上传成功后调用回调（如果存在）
      if (saveCallback && typeof saveCallback === 'function') {
        await saveCallback();
      }
    } catch (error) {
      console.error("上传到智翎云境失败:", error);
      message.error("上传失败");
    }
  };

  const { screenshot, setScreenshot } = useContext(ProjectContext);
  useEffect(() => {
    if (screenshot) {
      const stageElement = document.querySelector(".stage");
      if (stageElement) {
        html2canvas(stageElement, { scale: 2, useCORS: true }).then((canvas) => {
          const dataUrl = canvas.toDataURL("image/png");
          const link = document.createElement("a");
          link.href = dataUrl;
          link.download = "screenshot.png";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
      }
      setScreenshot(false); // 重置screenshot状态
    }
  }, [screenshot]);

  return (
    <div className="stage" onClick={handleClick}>
      <canvas ref={canvasRef} />
    </div>
  );
};

export default Home;
